import React, { useState, useEffect, useCallback } from 'react';
import constClass from '../../Constants/Constants';
import Common from '../Common/common';
//import moment from 'moment';
import axios from 'axios';
import moment from 'moment';
import QRCode from "react-qr-code";
import QrImg from '../Images/qr-code.svg';
import Loading from '../Loading/Loading';

const Benefit = ({ benefit, benefitTicketButtonClick, backClick, disabled, liffAccessToken, siteId, setting, preview, couponPreview }) => {

  const [qrData, setQrData] = useState(null);
  const [restTime, setRestTime] = useState(0);
  const [validTime, setValidTime] = useState(moment());

  const getQrData = useCallback(async () => {
    const qr_data = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/customer/line/benefit/qrdata/${siteId}/`, { site_id: siteId, line_id: liffAccessToken, benefit_id: benefit.benefit_id, issue_count: benefit.issue_count })).data;
    setQrData(qr_data);
    const date = moment();
    setValidTime(date + setting.BENEFIT_QRCODE_VALID_TIME * 60 * 1000);
  }, [siteId, liffAccessToken, setting, benefit.benefit_id, benefit.issue_count]);

  useEffect(() => {
    if (benefit.receiving_type === constClass.RECEIVING_TYPE.DIGITAL_TICKET_BUTTON || preview) return;
    getQrData();
  }, [getQrData, benefit.receiving_type, preview]);

  useEffect(() => {
    if (benefit.receiving_type === constClass.RECEIVING_TYPE.DIGITAL_TICKET_BUTTON || preview) {
      setRestTime(6000);
      return;
    }
    const intervalId = setInterval(() => {
      const date = moment();
      const sec = Math.floor((validTime - date) / 1000);
      setRestTime(sec);
      if (sec <= 0) {
        getQrData();
      }
    }, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, [validTime, getQrData, benefit, benefit.receiving_type, preview]);

  return (
    <div id="ticketUse" className="ticket-use">
      {!preview && !benefit.receiving_type === constClass.RECEIVING_TYPE.DIGITAL_TICKET_BUTTON && (qrData === null || restTime === 0) ? (
        <Loading />
      ) : (
        <React.Fragment>
            <div className="ticket-detail-use">
              <div className="group13">
                <div className="frame50">
                  {benefit.benefit_image_url && <img className="ticket-detail-image" src={`/${siteId}/${constClass.BENEFIT_IMAGE_DIR}${benefit.benefit_image_url}`} alt={benefit.benefit_title} style={{ objectFit: 'cover' }} />}
                  {!benefit.benefit_image_url && <img className="ticket-detail-image" src={`/${siteId}/nodetailimage.png`} alt="nodetailimage" style={{ objectFit: 'cover' }} />}
                  {benefit.receiving_type === constClass.RECEIVING_TYPE.DIGITAL_TICKET_BUTTON &&
                    <div className="buttonticketframe49">
                      <div className="ticket-detail-text">{Common.getBrString(benefit.benefit_detail)}</div>
                    </div>
                  }
                  {benefit.receiving_type === constClass.RECEIVING_TYPE.DIGITAL_TICKET_QR &&
                    <React.Fragment>
                      <div className="group10">
                        <div className="ellipse12">
                          {(!benefit.use_date && benefit.invalid_flag !== constClass.FLAG.ON) && (
                            <React.Fragment>
                              {qrData && (
                                <div className="qr-box">
                                  <QRCode className="qr-detail-img" size={100} value={qrData} />
                                </div>
                              )}
                              {!qrData && (
                                <div className="qr-preview">
                                  <img className="qr-detail-img" src={QrImg} size={500} alt={"QRコード"} />
                                </div>
                              )}
                            </React.Fragment>
                          )}
                        </div>
                      </div>
                      <div className="frame49">
                        <div className="ticket-detail-text">{Common.getBrString(benefit.benefit_detail)}</div>
                      </div>
                    </React.Fragment>
                  }
                </div>
              </div>
            </div>
          <div className="frame54">
            {benefit.receiving_type === constClass.RECEIVING_TYPE.DIGITAL_TICKET_BUTTON &&
              <React.Fragment>
                <div className="text-center">
                  <div className="button-ticketuse-text">
                    この画面を店舗スタッフへご提示ください。
                  </div>
                  <div className="button-ticketuse-text">
                    以下のボタンは店舗用です。
                  </div>
                  <div className="button-ticketuse-text">
                    タップすると特典を利用します。
                  </div>
                  <button
                    disabled={disabled}
                    className="button-ticketuse text-white"
                    onClick={benefitTicketButtonClick(benefit.issue_count, benefit.benefit_id)}>
                    使用する
                  </button>
                </div>
                <div className='vector17'></div>
              </React.Fragment>
            }
            {benefit.limit_date !== '9999-12-31' &&
              <React.Fragment>
                <div className="frame59">
                  <div className="ticket_notes mb-2">有効期限</div>
                  <div className="frame56">
                    {Common.getDateObject1(benefit.limit_date).str}
                  </div>
                </div>
              </React.Fragment>
            }
            {!couponPreview &&
              <div className="text-center mb-4">
                <button
                  className="button text-black bg-lightwhite buckbutton"
                  onClick={backClick}>
                  戻る
                </button>
              </div>
            }
          </div>
        </React.Fragment>
      )}
    </div>
  )
}

export default Benefit;